import { render, staticRenderFns } from "./foreigndocview.vue?vue&type=template&id=06820c4d&scoped=true&"
import script from "./foreigndocview.vue?vue&type=script&lang=js&"
export * from "./foreigndocview.vue?vue&type=script&lang=js&"
import style0 from "./foreigndocview.vue?vue&type=style&index=0&id=06820c4d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06820c4d",
  null
  
)

export default component.exports